import React from 'react';

import EntityInformation from './EntityInformation';
import EntityExperian from './EntityExperian';

class SectionContent extends React.Component {

    render() {

        return (
            <div>
                {
                    this.props.companyData ?
                        <EntityInformation companyData={this.props.companyData} experianData={this.props.experianData}/>
                        :
                        null
                }
                        <EntityExperian
                            companyId={this.props.companyId}
                            experianData={this.props.experianData}
                            companyData={this.props.companyData}/>
            </div>
        );
    }

}

export default SectionContent;


// WEBPACK FOOTER //
// ./src/scripts/pages/EntityDashboard/components/AboutThisEntity/components/SectionContent.jsx